import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

function NavItem({ name, to }) {
	const className = ({ isActive }) =>
		`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
			isActive
				? 'bg-[--color-bg-tertiary] text-[--color-text-primary]'
				: 'text-[--color-text-secondary] hover:bg-[--color-bg-secondary] hover:text-[--color-text-primary]'
		}`;

	return (
		<li>
			<NavLink to={to} className={className}>
				{name}
			</NavLink>
		</li>
	);
}

NavItem.propTypes = {
	name: PropTypes.string.isRequired,
	to: PropTypes.string.isRequired,
};

export default NavItem;
